/**
 * @generated SignedSource<<813d8dd1f21d62bee20ed2c658703147>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedBlurbRareFind_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedRecentSalesCopy_item" | "useIsRareFind_item">;
  readonly " $fragmentType": "PdpSharedBlurbRareFind_item";
};
export type PdpSharedBlurbRareFind_item$key = {
  readonly " $data"?: PdpSharedBlurbRareFind_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedBlurbRareFind_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedBlurbRareFind_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedRecentSalesCopy_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useIsRareFind_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "2476553690865a595620f466140effee";

export default node;
